// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".aroma-sleep-stage-chart[data-v-1ef5e0dd]{overflow:hidden;border:1px solid #dce8f2;border-radius:2.13333vw;background:#f8fcff}.aroma-sleep-stage-chart__canvas[data-v-1ef5e0dd]{width:100%;height:64vw}", ""]);
// Exports
module.exports = exports;
